import * as ActionTypes from '../BettingMode';
export function toggleOneClickMode(data) {
    return { type: ActionTypes.TOGGLE_ONE_CLICK_MODE, data: data };
}
export function setOneClickAmount(data) {
    return { type: ActionTypes.SET_ONE_CLICK_AMOUNT, data: data };
}
export function toggleAcceptFactorIncrease(data) {
    return { type: ActionTypes.TOGGLE_ACCEPT_FACTOR_INCREASE, data: data };
}
export function toggleAcceptFactorDecrease(data) {
    return { type: ActionTypes.TOGGLE_ACCEPT_FACTOR_DECREASE, data: data };
}



// WEBPACK FOOTER //
// ./src/actions/creators/BettingMode.js